import { render, staticRenderFns } from "./BuscadorSucursales.vue?vue&type=template&id=c21b9fa4&scoped=true&"
import script from "./BuscadorSucursales.vue?vue&type=script&lang=js&"
export * from "./BuscadorSucursales.vue?vue&type=script&lang=js&"
import style0 from "./BuscadorSucursales.vue?vue&type=style&index=0&id=c21b9fa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21b9fa4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})
